class LazyAutoplayVideo extends HTMLVideoElement {
  constructor() {
    super()

    // Options for the observer (which margins to apply)
    const options = {
      root: null,
      rootMargin: '300px 0px 300px 0px', // 300px margin vertically
      threshold: 0,
    }

    // Create an intersection observer instance
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.play()
        } else {
          this.pause()

          if (this.alwaysRestart) {
            this.currentTime = 0
          }
        }
      })
    }, options)
  }

  connectedCallback() {
    // Start observing the video element
    this.observer.observe(this)
    this.alwaysRestart = this.getAttribute('data-always-restart')
  }

  disconnectedCallback() {
    // Stop observing the video element
    this.observer.unobserve(this)
  }
}

// Define the custom element
customElements.define('lazy-autoplay-video', LazyAutoplayVideo, {
  extends: 'video',
})
